/**
 * 模板市场-列表状态定义与同步
 * @author VenDream
 * @since 17/11/29
 */

import VARIABLES from 'constants/variable.json5';
import ACTIONS from 'constants/action.json5';

const initialState = {
  // 状态：0 = 已就绪，1 = 正在加载， 2 = 加载失败， 3 = 已加载所有数据
  status: 0,
  showPosterModal: false,
  [VARIABLES.RECOMMEND]: [],
  [VARIABLES.RP_STORE]: [],
  [VARIABLES.RP_H5]: [],
  [VARIABLES.RP_SPA]: [],
  [VARIABLES.RP_VIDEO]: [],
  [VARIABLES.CHAJIAN]: [],
  [VARIABLES.RP_GAME]: [],
  [VARIABLES.VIP]: [],
  [VARIABLES.ENTERPRISE]: [],
  [VARIABLES.MY_TPL]: [],
  [VARIABLES.SEARCH]: [],
  [VARIABLES.SHOWPAGE]: [],
  [VARIABLES.OPENEDPAGE]: [],
  [VARIABLES.OPENEDPLUGIN]: [],
  [VARIABLES.POSTER]: [],
  [VARIABLES.OPENZONE]: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_TPLS_ING: {
      return { ...state, status: 1 };
    }
    case ACTIONS.GET_TPLS_SUCCEED: {
      const { category, tpls, totalRecords, loadType } = action.payload;
      return {
        ...state,
        status: 0,
        totalRecords,
        [category]:
          loadType === 'click'
            ? tpls.map(tpl => tpl.id)
            : state[category].concat(tpls.map(tpl => tpl.id)),
      };
    }
    case ACTIONS.GET_TPLS_FAILED: {
      return { ...state, status: 2 };
    }
    case ACTIONS.GET_TPLS_ENDED: {
      return { ...state, status: 3 };
    }
    case ACTIONS.CLEAR_STORE_TPLS: {
      return { ...state, ...initialState };
    }
    case ACTIONS.TOGGLE_POSTER_MODAL: {
      return { ...state, showPosterModal: action.data };
    }
    default:
      return state;
  }
};
